import {FC} from 'react'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {formatCNPJ} from '../../../../../../utils/formats'
import {EmptyState} from '../EmptyState'
import styles from '../../styles.module.css'

type Props = {
  unitBranchs?: any[]
}

const UnitBranchLinkedClient: FC<Props> = ({unitBranchs = []}) => {
  if (!unitBranchs || !unitBranchs.length) {
    return (
      <EmptyState
        icon='/media/icons/duotune/ecommerce/ecm009.svg'
        title='Nenhuma filial vinculada'
        text='Edite o cliente para definir a filial responsável por ele.'
      />
    )
  }

  return (
    <div className={styles.cardList}>
      {unitBranchs.map((unitBranch: any) => (
        <div key={unitBranch.id} className={styles.itemCard}>
          <span className={styles.itemIcon}>
            <KTSVG
              path='/media/icons/duotune/ecommerce/ecm009.svg'
              className='svg-icon-2x svg-icon-primary'
            />
          </span>
          <div className={styles.itemText}>
            <span className={styles.itemTitle} title={unitBranch.companyName}>
              {unitBranch.companyName || 'Filial sem nome'}
            </span>
            <div className={styles.itemMeta}>
              <span>
                <i className='bi bi-building text-gray-500'></i>
                {unitBranch.cnpj ? formatCNPJ(String(unitBranch.cnpj)) : 'CNPJ não informado'}
              </span>
              <span>
                <i className='bi bi-envelope text-gray-500'></i>
                {unitBranch.emailCompany || 'E-mail não informado'}
              </span>
            </div>
          </div>
          {unitBranch.tipo && (
            <span
              className={`badge fs-8 fw-bold ${
                unitBranch.tipo === 'MATRIZ' ? 'badge-light-primary' : 'badge-light'
              }`}
            >
              {unitBranch.tipo === 'MATRIZ' ? 'Matriz' : 'Filial'}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}

export {UnitBranchLinkedClient}
